import * as React from 'react';
export const IcInsemination = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 4c-1.68-1.69-4.75-1.26-7 1-1.91 1.91-2.49 4.43-1.57 6.17l-.14.12a2.71 2.71 0 00-.57 2.58c.1.58.1.72 0 .83-.1.11-.26.11-.83 0a2.662 2.662 0 00-2.58.57 2.69 2.69 0 00-.58 2.58c.1.58.1.72 0 .84s-.26.11-.83 0a2.701 2.701 0 00-2.59.57 1 1 0 000 1.42.998.998 0 001.42 0c.11-.11.26-.12.83 0a2.66 2.66 0 002.58-.57 2.69 2.69 0 00.58-2.58c-.1-.58-.1-.73 0-.84.1-.11.26-.11.83 0a2.68 2.68 0 002.58-.57 2.69 2.69 0 00.58-2.58c-.1-.58-.1-.73 0-.83a.31.31 0 01.23-.09c.527.256 1.104.39 1.69.39A6.36 6.36 0 0019 11c2.23-2.23 2.67-5.3 1-7z'
      fill='currentColor'
    />
  </svg>
);
